import { ArrowRight, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { BlogPostMeta } from '../lib/blog';

export function BlogCard({ post }: { post: BlogPostMeta }) {
  return (
    <Link
      to={`/blog/${post.slug}`}
      className="group flex h-full flex-col overflow-hidden rounded-2xl border border-neutral-800 bg-neutral-950 transition hover:-translate-y-0.5 hover:border-yellow-400/30"
    >
      <div className="relative aspect-[16/9] overflow-hidden bg-neutral-900">
        <img
          src={post.image}
          alt={post.title}
          className="h-full w-full object-cover transition duration-500 group-hover:scale-[1.02]"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent" />
        <div className="absolute bottom-3 left-3">
          <span className="rounded-full bg-yellow-400 px-2.5 py-1 text-xs font-bold text-black">
            {post.category}
          </span>
        </div>
      </div>

      <div className="flex flex-1 flex-col p-5 sm:p-6">
        <div className="flex flex-wrap items-center gap-2 text-xs text-neutral-500">
          <span>{post.date}</span>
          <span aria-hidden="true">•</span>
          <span className="inline-flex items-center gap-1">
            <Clock className="h-3.5 w-3.5" />
            {post.readTime}
          </span>
        </div>

        <h3 className="mt-3 text-lg font-bold leading-snug text-white transition group-hover:text-yellow-300 sm:text-xl">
          {post.title}
        </h3>

        <p className="mt-3 line-clamp-3 text-sm leading-6 text-neutral-400">
          {post.excerpt}
        </p>

        <span className="mt-5 inline-flex items-center text-sm font-bold text-yellow-400">
          Read article
          <ArrowRight className="ml-1.5 h-4 w-4 transition-transform group-hover:translate-x-1" />
        </span>
      </div>
    </Link>
  );
}
